/** @jsxImportSource @emotion/react */
import { OffersAlternative } from "./landing/offers/OffersAlternative"
import { Title } from "./landing/title/Title"
import { AboutMe } from "./landing/aboutMe/AboutMe"
import { Reviews } from "./landing/reviews/Reviews"
import { Portfolio } from "./landing/portfolio/Portfolio"
import { Voucher } from "./landing/voucher/Voucher"
import { Contact } from "./landing/contact/Contact"
import { Footer } from "./landing/footer/Footer"
import { Studio } from "./landing/studio/Studio"
import { AppContentHelmet } from "../helmet/AppContentHelmet"
import { LoadingIndicator } from "./components/LoadingIndicator"
import { preloadImages } from "./utils/ImagePreloader"
import { useEffect, useState } from "react"

export const AppContent = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Preload critical images
        preloadImages()
            .then(() => {
                // Add a small delay to ensure smooth transition
                setTimeout(() => {
                    setIsLoading(false);
                }, 300);
            })
            .catch(error => {
                console.error('Error preloading images:', error);
                // If there's an error, still show the content after a timeout
                setTimeout(() => {
                    setIsLoading(false);
                }, 1000);
            });
    }, []);

    return <>
        <AppContentHelmet />
        <LoadingIndicator isLoading={isLoading} />
        {/* <LanguageSwitcher /> */}
        <Title />
        <AboutMe />
        <Studio />
        <OffersAlternative />
        <Portfolio />
        <Voucher />
        <Reviews />
        <Contact />
        <Footer />
    </>
}